import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=7d51ab7b&lang=pug&"
import script from "./pieChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./pieChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pieChart.vue?vue&type=style&index=0&id=7d51ab7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports